/**
 * Created by xiaojielin on 17/1/3.
 */
import axios from 'axios'
import Qs from 'qs'
import store from '../store/user.js'
import utils from '../utils/common.js'

const api = axios.create({
  baseURL: 'https://www.safetytaxfree.org/rest/v1/',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data) {
    return Qs.stringify(data)
  }]
})

// Add a request interceptor
api.interceptors.request.use(function (config) {
  // add auth apiKey
  if (!utils.isEmptyObject(store.getters.getUserInfo)) {
    config.headers['Authorization'] = store.getters.getUserInfo.apiKey
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

export default api



// WEBPACK FOOTER //
// ./src/service/api.js